import { motion } from 'framer-motion';
import { Bot, Users, TrendingDown } from 'lucide-react';

const problems = [
  {
    icon: Bot,
    title: 'AI chatbots process cancellations — they don\'t prevent them',
    desc: 'Automated flows are built for efficiency, not empathy. They confirm cancellations in seconds instead of attempting to save the customer.',
  },
  {
    icon: Users,
    title: 'Generic support teams aren\'t trained in retention psychology',
    desc: 'Customer service agents are trained to resolve tickets. Retention is a completely different skill set that most support teams simply don\'t have.',
  },
  {
    icon: TrendingDown,
    title: 'Every lost subscriber is recurring revenue gone forever',
    desc: 'Churn is compounding. Lose 5% a month and you\'ve lost over half your subscribers in a year. Each cancellation is more expensive than it appears.',
  },
];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="py-28 px-6 lg:px-10 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-4">
            The Problem
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#0A1628] max-w-2xl leading-tight">
            Subscription businesses bleed revenue every month
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                data-testid={`problem-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6, boxShadow: '0 20px 60px rgba(10,22,40,0.10)' }}
                className="bg-white rounded-2xl p-8 shadow-[0_8px_32px_rgba(10,22,40,0.05)] border border-[#0A1628]/5 cursor-default transition-shadow duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-[#00D4B8]/10 flex items-center justify-center mb-6">
                  <Icon size={22} strokeWidth={1.5} className="text-[#00D4B8]" />
                </div>
                <h3 className="text-base font-semibold text-[#0A1628] leading-snug mb-3">
                  {p.title}
                </h3>
                <p className="text-sm text-[#1A1A1A]/55 leading-relaxed">
                  {p.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
